import React from "react";
import HeaderComponent from "./HeaderComponent";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
const FeedComponentUsers = (props) => {
  var loginData = localStorage.getItem("loginData");
  if (loginData && loginData != null && typeof JSON.parse(loginData) === "object") {
    debugger;
    window.smartlook("identify", JSON.parse(loginData).user.id, {
      name: JSON.parse(loginData).user.user_name,
      email: JSON.parse(loginData).user.user_email,
    });
  }
  debugger;
  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <HeaderComponent
      // whiteLabel={this.state.isWhiteLabel}
      // headerData={{ studentName: this.state.teacherInfo.user_name }}
      />

      {loginData != null &&
      typeof JSON.parse(loginData) === "object" &&
      JSON.parse(loginData).is_em == 1 ? (
        <Modal isOpen={true} centered size="md" className="modalModal" backdrop={true}>
          <ModalHeader className="modalMultiRole">Login As:</ModalHeader>
          <ModalBody className="modalMultiRole">For which role do you want to login as?</ModalBody>
          <ModalFooter className="modalMultiRole">
            <Link to="/dashboard">
              <Button color="primary">Education Mama</Button>
            </Link>
            <Link to="/Teacherdashboard">
              <Button color="warning">Teacher</Button>
            </Link>
          </ModalFooter>
        </Modal>
      ) : loginData != null &&
        typeof JSON.parse(loginData) === "object" &&
        JSON.parse(loginData).user_type == 1 ? (
        <Redirect to="/Teacherdashboard" />
      ) : loginData != null &&
        typeof JSON.parse(loginData) === "object" &&
        JSON.parse(loginData).user_type == 2 ? (
        <Redirect to="/dashboard" />
      ) : loginData != null &&
        typeof JSON.parse(loginData) === "object" &&
        JSON.parse(loginData).user_type == 0 ? (
        <Redirect to={`/${JSON.parse(loginData).user.id}`} />
      ) : (
        ""
      )}
      {/* {loginData != null &&
        typeof JSON.parse(loginData) === "object" &&
        JSON.parse(loginData).user_type == 1 ? (
          <Redirect to="/Teacherdashboard" />
        ) : loginData != null &&
          typeof JSON.parse(loginData) === "object" &&
          JSON.parse(loginData).user_type == 2 ? (
            <Redirect to="/dashboard" />
          ) : (
            ""
          )} */}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    loginUserType: state.feedRed.loginSuccessNormal.user_type,
  };
}
export default connect(mapStateToProps, null)(FeedComponentUsers);
